import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from 'dayjs'
dayjs.extend(customParseFormat);

export const FormatDateDayjs = (dateString: string, dateFormat = "DD/MM/YYYY"): any => {
    return dayjs(dateString, dateFormat)
  };
  